import React from 'react'
import { BsGithub } from "react-icons/bs";
import { FaGlobe } from "react-icons/fa";
import { iconFor } from "../layouts/techIcons";

const iconClass =
  "text-lg w-10 h-10 rounded-full bg-black/40 inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer";

const ProjectsCard = ({ title, des, tags = [], github, live, status, context, metric }) => {
  return (
    <div className="card w-full h-full p-5 flex flex-col group hover:border-designColor/40 hover:-translate-y-2 transition-all duration-500">
      <div className="w-full h-36 overflow-hidden rounded-xl relative bg-gradient-to-br from-[#2a2e33] via-[#1b1d20] to-[#141518] flex items-center justify-center">
        {status && (
          <span className="absolute top-3 left-3 z-10 text-xs uppercase tracking-wider px-3 py-1 rounded-full bg-designColor text-white">
            {status}
          </span>
        )}
        <div className="absolute w-40 h-40 rounded-full bg-designColor/20 blur-3xl group-hover:bg-designColor/30 duration-500"></div>
        <div className="relative flex items-center gap-6 text-4xl text-gray-400 group-hover:text-white group-hover:scale-110 duration-500">
          {tags.slice(0, 4).map((tag) => (
            <span key={tag}>{iconFor(tag)}</span>
          ))}
        </div>
      </div>
      <div className="w-full mt-5 flex flex-col gap-4 flex-1">
        <div className="flex items-start justify-between gap-2">
          <div>
            {context && (
              <p className="text-xs uppercase tracking-[2px] text-gray-500 mb-1">{context}</p>
            )}
            <h3 className="text-lg text-white font-semibold font-titleFont leading-snug">
              {title}
            </h3>
          </div>
          <div className="flex gap-2 shrink-0">
            {github && (
              <a href={github} target="_blank" rel="noreferrer" aria-label={`${title} source code`} className={iconClass}>
                <BsGithub />
              </a>
            )}
            {live && (
              <a href={live} target="_blank" rel="noreferrer" aria-label={`${title} live demo`} className={iconClass}>
                <FaGlobe />
              </a>
            )}
          </div>
        </div>
        {metric && (
          <p className="self-start text-sm font-semibold text-designColor bg-designColor/10 border border-designColor/30 rounded-lg px-3 py-1.5">
            {metric}
          </p>
        )}
        <p className="text-sm tracking-wide leading-6 text-gray-400">
          {des}
        </p>
        <div className="flex flex-wrap gap-2 mt-auto pt-2">
          {tags.map((tag) => (
            <span key={tag} className="chip">{tag}</span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProjectsCard
